import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import useSliderImageSrcSizes from 'Components/Utility/SiteSlider/hooks/useSliderImageSrcSizes';
import CarouselCard from 'Components/Carousel/CardPanelCarousel/CarouselCard';
import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';

import 'Components/Carousel/CardPanelCarousel/CardPanelCarousel.scss';

export default function MobileCardPanelCarousel({
  slides,
  fantasyVerse,
  title,
}) {
  const cardSrcSizes = useSliderImageSrcSizes((slides || []).length);

  const sortedSlides = useMemo(() => slides.sort((a, b) => a.sort_order - b.sort_order), [slides]);

  const sliderSettings = {
    xs: {
      mobileSlidePercent: 0.6, // on XS, each slide takes 60% of the width of the screen
    },
  };

  return (
    <React.Fragment>
      <h2 className="MobileCardPanelCarouselHeading">
        {title || <FormattedMessage id="mobile-card-panel-carousel.title" defaultMessage="Featured Deals" />}
      </h2>

      <div className="MobileCardPanelCarousel">
        <div className="MobileCardPanelCarousel__main">
          <CarouselCard
            size={'large'}
            card={sortedSlides[0]}
            cardNumber={1}
            fantasyVerse={fantasyVerse}
          />
        </div>

        <div className="MobileCardPanelCarousel__slider">
          <SiteSlider sliderClass="ProductCardCarousel" sliderSettings={sliderSettings}>
            {sortedSlides.slice(1).map((slide, i) =>
              <CarouselCard
                key={slide._id}
                card={slide}
                cardNumber={i + 2}
                fantasyVerse={fantasyVerse}
                sizesOverride={cardSrcSizes}
              />,
            )}
          </SiteSlider>
        </div>
      </div>
    </React.Fragment>
  );
}

MobileCardPanelCarousel.propTypes = {
  slides: PropTypes.array,
  fantasyVerse: PropTypes.bool,
  title: PropTypes.string,
};

MobileCardPanelCarousel.defaultProps = {
  slides: [],
  fantasyVerse: false,
  title: '',
};
